/**
 * Guard React against third-party DOM mutation (Google Translate, password
 * managers, other extensions). When an extension wraps or moves text nodes,
 * React's reconciler later calls removeChild/insertBefore with stale
 * references and crashes with:
 *   NotFoundError: Failed to execute 'insertBefore' on 'Node': The node
 *   before which the new node is to be inserted is not a child of this node.
 * (Seen in production on /signup — Sentry issue 137334097, Chrome + translate.)
 *
 * Standard mitigation from facebook/react#11538: make both calls no-ops for
 * stale nodes instead of throwing. Worst case is a transient visual glitch
 * in the translated text; without it the whole tree unmounts to the error
 * boundary and the user loses the page.
 */
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild
  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) {
      if (console) {
        console.warn('domNodePatch: skipped removeChild on detached node (browser extension mutated the DOM)')
      }
      return child
    }
    return originalRemoveChild.call(this, child) as T
  }

  const originalInsertBefore = Node.prototype.insertBefore
  Node.prototype.insertBefore = function <T extends Node>(
    this: Node,
    newNode: T,
    referenceNode: Node | null,
  ): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (console) {
        console.warn('domNodePatch: skipped insertBefore with detached reference node (browser extension mutated the DOM)')
      }
      return newNode
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T
  }
}

export {}
